import common from "../common";
import Scene from "../scenes/Scene";
import Button from "../ui/Button";
import Text from "../ui/Text";
import ToggleButton from "../ui/ToggleButton";
import TutorialWindow from "../game/TutorialWindow";

export default class PauseOverlay extends Scene {
    constructor()
    {
        super('PauseOverlay');

        this.tutorialWindow = null;
    }

    init()
    {
        super.init();

        this.bg = common.display.container({parent:this});

        var bg = common.display.sprite({parent:this, alpha:0.2, texture:common.display.colourTextures.lightBlue});
        bg.scale.x = common.STAGE_WIDTH / this.bg.width;
        bg.scale.y = common.STAGE_HEIGHT / this.bg.height;
        bg.interactive = true;

        common.display.sprite({asset:'glow_25_pc', tint:common.display.colours.lightBlue, x:common.STAGE_HALF_WIDTH, y:common.STAGE_HALF_HEIGHT - 300, anchor:0.5, scale:6, parent:this.bg});
        common.display.sprite({asset:'glow_25_pc', tint:common.display.colours.lightBlue, x:common.STAGE_HALF_WIDTH, y:common.STAGE_HALF_HEIGHT + 200, anchor:0.5, scale:6, parent:this.bg});

        this.pausePanel = common.display.sprite({asset:'panel_help', x:common.STAGE_HALF_WIDTH, y:common.STAGE_HALF_HEIGHT-100, anchor:0.5, parent:this});

        var windowScale = 0.75;
        this.tutorialWindow = new TutorialWindow(this, common.config.characters[common.character], 485 / windowScale, 362 / windowScale);
        this.tutorialWindow.scale.set(windowScale);
        this.pausePanel.addChild(this.tutorialWindow);

        var titleText = new Text(common.text.translate('paused'), {
            font: 55 + "px Lalezar48",
            align: "center"/*,
            tint: 0x000000*/
        });
        titleText.x = common.STAGE_HALF_WIDTH;
        titleText.y = 55;
        titleText.anchor.set(0.5);
        this.addChild(titleText);

        this.buttons.charSelect = new Button(new P3.ButtonStates(
            P3.assets.texture('secondary_large_character_select_out'),
            P3.assets.texture('secondary_large_character_select_over'),
            P3.assets.texture('secondary_large_character_select_down'),
            P3.assets.texture('character_select_icon')
        ));
        this.buttons.charSelect.id = 'charSelect';
        this.buttons.charSelect.y = common.STAGE_HEIGHT - 200;
        this.buttons.charSelect.x = common.STAGE_HALF_WIDTH - 200;
        this.signalListeners.push(this.buttons.charSelect.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.charSelect);

        this.buttons.restart = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_secondary_large_out'),
            P3.assets.texture('btn_secondary_large_over'),
            P3.assets.texture('btn_secondary_large_down'),
            P3.assets.texture('icon_restart')
        ));
        this.buttons.restart.id = 'restart';
        this.buttons.restart.y = common.STAGE_HEIGHT - 200;
        this.buttons.restart.x = common.STAGE_HALF_WIDTH - 70;
        this.signalListeners.push(this.buttons.restart.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.restart);
        
        var muteStates = new P3.ButtonStates(
            P3.assets.texture('btn_secondary_large_out'),
            P3.assets.texture('btn_secondary_large_over'),
            P3.assets.texture('btn_secondary_large_down'),
            P3.assets.texture('icon_sound_on')
        );
        muteStates.iconAlt = P3.assets.texture('icon_sound_off');

        this.buttons.mute = new ToggleButton(muteStates);
        this.buttons.mute.id = 'mute';
        this.buttons.mute.y = common.STAGE_HEIGHT - 200;
        this.buttons.mute.x = common.STAGE_HALF_WIDTH + 70;
        this.signalListeners.push(this.buttons.mute.signals.click.add(this.onMuteClicked, this));
        if(common.audio.isMute)
        {
            this.buttons.mute.toggle();
        }
        this.addChild(this.buttons.mute);

        this.buttons.resume = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_large_out'),
            P3.assets.texture('btn_primary_large_over'),
            P3.assets.texture('btn_primary_large_down'),
            P3.assets.texture('icon_play')
        ));
        this.buttons.resume.id = 'resume';
        this.buttons.resume.icon.anchor.set(0.45, 0.53);
        this.buttons.resume.y = common.STAGE_HEIGHT - 200;
        this.buttons.resume.x = common.STAGE_HALF_WIDTH + 230;
        this.signalListeners.push(this.buttons.resume.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.resume);

        this.addHomeButton();

        this.pausePanel.scale.set(0.2);
        TweenMax.to(this.pausePanel.scale, 1, {x:1, y:1, ease:Elastic.easeOut});

        this.bg.alpha = 0;
        TweenMax.to(this.bg, 0.5, {alpha:1});
        
        var count = 0;
        for(var i in this.buttons)
        {
            this.buttons[i].appear(count*0.2);
            count++;
        }

        common.audio.playSound('music_pause_loop', this.audioLoopParams);
    }

    destroy()
    {
        common.audio.stopSound('music_pause_loop');
        super.destroy();
    }

    update()
    {
        super.update();

        this.tutorialWindow.update();
    }

    resize()
    {
        super.resize();
    }

    animateOut(callback)
    {
        TweenMax.to(this.pausePanel.scale, 0.5, {x:0, y:0, ease:Back.easeIn, onComplete:callback});
        TweenMax.to(this.bg, 0.3, {alpha:0});

        var count = 0;
        for(var i in this.buttons)
        {
            this.buttons[i].disappear(count*0.05);
            count++;
        }
    }

    onButtonClicked(button)
    {
        if(button.id == 'resume')
        {
            this.animateOut(() => {
                this.signals.next.dispatch(button.id);
            });
        }
        else
        {
            this.signals.next.dispatch(button.id);
        }
    }

    onMuteClicked(button)
    {
        console.log('onMuteClicked', button.toggled);
        common.audio.mute(button.toggled);
    }
}